import { useMutation } from '@tanstack/react-query';
import { gqlClient, graphql, type NotificationReadInput } from '@tyro/api';

const markNotificationRead = graphql(`
  mutation communications_readNotification($input: NotificationReadInput) {
    communications_readNotification(input: $input) {
      success
    }
  }
`);

export function useMarkNotificationRead() {
  return useMutation({
    mutationFn: async (input: NotificationReadInput) =>
      gqlClient.request(markNotificationRead, { input }),
  });
}
